import { get, set } from 'lodash';
import { UseFormRegisterReturn } from 'react-hook-form';

export function trimOnBlur(event: FocusEvent, register: UseFormRegisterReturn): Promise<void | boolean> {
  const value = get(event, 'target.value', '');
  set(event, 'target.value', value.trim());
  return register.onBlur(event);
}
